import { SectionLeading } from '@sbercloud/uikit-product-site-section';
import { useLayoutType } from 'src/hooks/useLayoutType';

const DATA = {
  title: 'Cloud.ru – ведущий провайдер облачных и AI‑технологий',
  mark: '*По объему выручки IaaS- и PaaS-сервисов за 2024 год (по данным iKS-Consulting), AI-сервисов за 2023 год (по данным CNews Analytics).',
  slides: [
    {
      id: '1',
      value: '№1',
      label: 'в сегменте IaaS',
      description: 'iKS-Consulting, 2024',
      image: 'https://cdn.cloud.ru/backend/images/about/preview1.webp',
    },
    {
      id: '2',
      value: '№1',
      label: 'в сегменте PaaS',
      description: 'iKS-Consulting, 2024',
      image: 'https://cdn.cloud.ru/backend/images/about/preview2.webp',
    },
    {
      id: '3',
      value: '№1',
      label: 'на рынке AI',
      description: 'CNews Analytics, 2024',
      image: 'https://cdn.cloud.ru/backend/images/about/preview3.webp',
    },
  ],
};

interface AdvantagesCarouselProps {
  id?: string;
  title?: string;
  note?: string;
  className?: string;
}

export function AdvantagesCarousel({
  id,
  title,
  note,
}: AdvantagesCarouselProps) {
  const layoutType = useLayoutType();

  return (
    <SectionLeading
      id={id}
      title={title || DATA.title}
      description={note}
      footerDescription={DATA.mark}
      items={DATA.slides}
      layoutType={layoutType}
      data-test-id="advantages-carousel"
      data-attribute="no_search_index"
    />
  );
}
